module.exports = __webpack_public_path__ + "img/hotdog.fb76a311.png";